// Typography classes matching Figma specs:
//   Body/S Medium (labels, form field titles): 13/16 Regular 400
//   Button/S (buttons, pill toggles, tabs):    13/16 Medium 500
//   Button/M (event title, target value, Yes/No toggle): 16/22 Medium 500
// Project's `font-medium` maps to weight 600, so explicit weight literals are used.
export const LABEL_CLASS = 'text-[13px] leading-4 font-normal text-v2-text-primary';
export const LABEL_MUTED_CLASS = 'text-[13px] leading-4 font-normal text-v2-text-secondary';
export const BUTTON_S_CLASS = 'text-[13px] leading-4 font-[500]';
export const BUTTON_M_CLASS = 'text-base leading-[22px] font-[500]';

export const NOTE_MAX = 100;

export const ACTIVE_ALERTS_MAX = 20;

// Max int32 z-index — needed to layer above third-party overlays (e.g. tawk-chat portal).
export const Z_OVERLAY_MAX = 2147483647;

export const TOOLTIP_CONTENT_CLASS =
  'block max-w-[280px] rounded-[10px] border border-v2-border bg-v2-btn-secondary-hover p-3 text-left text-[12px] leading-4 font-normal text-v2-text-primary dark:border-0 dark:bg-v2-surface-tertiary';
